import React from "react";
import { Menu } from "@base-ui/react/menu";

import { IconButton } from "../icon-button";
import { Icon } from "../icon";
import { HamburgerIcon } from "../../icons/icons";
import { FloatingMenu } from "../floating-menus/floating-menu";
import { BackMenuItem } from "../floating-menus/back-menu-item";
import { InfoMenuItem } from "../floating-menus/info-menu-item";
import { MySavedProductsMenuItem } from "../floating-menus/my-saved-products-menu-item";
import { ResetCdnUrlMenuItem } from "../floating-menus/reset-cdn-url-menu-item";
import { RestartMenuItem } from "../floating-menus/restart-menu-item";
import { SaveMenuItem } from "../floating-menus/save-menu-item";
import { ValidationsMenuItem } from "../floating-menus/validation-menu-item";
import { Version } from "../version";
import { useProductErrorsAndWarnings } from "../../hooks/useProductErrorsAndWarnings";
import { BadgeWrapper } from "../badge";

import "./hamburger-menu.css";

enum BadgeType {
	"error",
	"warning",
}

const HamburgerBadge = ({ badgeType }: { badgeType: BadgeType | null }) => {
	if (badgeType !== null) {
		if (badgeType === BadgeType.warning)
			return <BadgeWrapper className="hamburger-menu__badge--warning" />;
		if (badgeType === BadgeType.error)
			return <BadgeWrapper className="hamburger-menu__badge--error" />;
	}

	return null;
};

export function HamburgerMenu() {
	// Check Validation errors
	const { productErrorsAndWarnings } = useProductErrorsAndWarnings();
	const badgeType =
		productErrorsAndWarnings.length === 0
			? null
			: productErrorsAndWarnings.some((err) => err.isError)
			? BadgeType.error
			: BadgeType.warning;

	// https://base-ui.com/react/components/menu
	return (
		<Menu.Root>
			<Menu.Trigger
				render={(props, state) =>
					state.open ? (
						<IconButton {...props}>
							<Icon iconName="cross" />
						</IconButton>
					) : (
						<span style={{ position: "relative", display: "inline-block" }}>
							<IconButton {...props}>
								<HamburgerIcon />
							</IconButton>
							<HamburgerBadge badgeType={badgeType} />
						</span>
					)
				}
			></Menu.Trigger>
			<Menu.Portal>
				<Menu.Positioner align="start" alignOffset={5} side="bottom" sideOffset={5}>
					<Menu.Popup>
						<FloatingMenu>
							<SaveMenuItem />
							<RestartMenuItem />
							<InfoMenuItem />
							<BackMenuItem />
							<MySavedProductsMenuItem />
							<ValidationsMenuItem />
							<ResetCdnUrlMenuItem />
							<Version />
						</FloatingMenu>
					</Menu.Popup>
				</Menu.Positioner>
			</Menu.Portal>
		</Menu.Root>
	);
}
